var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"id":"pie","width":"290px","height":"290px","viewbox":"0 0 290 290"},domProps:{"innerHTML":_vm._s(_vm.svgData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }